
import { useEffect } from 'react';
import Hero from './components/Hero';
import FeaturedProducts from './components/FeaturedProducts';
import LeatherEducation from './components/LeatherEducation';
import PreOrderCTA from './components/PreOrderCTA';

export default function Home() {
  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://songlimkorea.com';

    const existingScripts = document.querySelectorAll('script[data-schema="home"]');
    existingScripts.forEach(s => s.remove());

    const orgSchema = {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "송림코리아",
      "url": siteUrl,
      "description": "경상북도 칠곡군에 위치한 자동차 교환부품 전문 공급업체. 라이트, 범퍼, 머드가드, 글로우 플러그 등 고품질 자동차 교환부품 공급.",
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "칠곡군",
        "addressRegion": "경상북도",
        "addressCountry": "KR"
      },
      "contactPoint": {
        "@type": "ContactPoint",
        "contactType": "customer service",
        "availableLanguage": "Korean"
      }
    };

    const webSiteSchema = {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "name": "송림코리아",
      "url": siteUrl,
      "description": "자동차 교환부품 전문 - 라이트, 범퍼, 머드가드 등 차량 교환부품을 안정적인 품질로 공급합니다.",
      "potentialAction": {
        "@type": "SearchAction",
        "target": {
          "@type": "EntryPoint",
          "urlTemplate": `${siteUrl}/shop?q={search_term_string}`
        },
        "query-input": "required name=search_term_string"
      }
    };

    const localBusinessSchema = {
      "@context": "https://schema.org",
      "@type": "AutoPartsStore",
      "name": "송림코리아",
      "url": siteUrl,
      "description": "자동차 교환부품 전문 공급업체. 라이트, 범퍼, 머드가드, 글로우 플러그 등 고품질 자동차 교환부품.",
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "칠곡군",
        "addressRegion": "경상북도",
        "addressCountry": "KR"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 35.9954,
        "longitude": 128.4017
      },
      "priceRange": "문의",
      "currenciesAccepted": "KRW",
      "paymentAccepted": "현금, 계좌이체"
    };

    [orgSchema, webSiteSchema, localBusinessSchema].forEach((schema, i) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.setAttribute('data-schema', 'home');
      script.textContent = JSON.stringify(schema);
      document.head.appendChild(script);
    });

    document.title = '송림코리아 - 자동차 교환부품 전문 | 라이트·범퍼·머드가드';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) metaDesc.setAttribute('content', '송림코리아는 경상북도 칠곡군 자동차 교환부품 전문 공급업체입니다. 라이트, 범퍼, 머드가드, 글로우 플러그, 램프류 등 고품질 자동차 교환부품을 안정적으로 공급합니다.');

    return () => {
      document.querySelectorAll('script[data-schema="home"]').forEach(s => s.remove());
    };
  }, []);

  return (
    <div>
      <Hero />
      <div>
        <FeaturedProducts />
      </div>
      <LeatherEducation />
      <div>
        <PreOrderCTA />
      </div>
    </div>
  );
}
